<div class="lvi-content list-view-item-hover" (click)="openDetail()">
    <div class="avatar danger">
        <i class="material-icons-outlined">credit_card</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ libelleErreur }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.numeroCarte'"></strong>
                <span>{{ data.numCarteClair }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.referenceInterne'"></strong>
                <span>{{ data.idOpeCarte }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.collaborateur'"></strong>
                <span>{{ data.collab }} - {{ data.matricule }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.montant'"></strong>
                <span>{{ data.montant | number:'.2-2' }} {{ data.devise }}</span>
            </li>
        </ul>
    </div>
</div>